<template>
  <main class="main page-inside rules-page">
    <div class="main-wrapper">
      <div class="section page-top-section">
        <div class="wrapper">
          <div class="title title-96">Community Guidelines</div>
          <img src="./../images/crew.webp" class="img" />
        </div>
      </div>
      <div class="section page-body-section">
        <div class="circle"></div>
        <div class="circle-2"></div>
        <div class="circle-3"></div>
        <img src="./../images/squares.webp" class="squares" />
        <div class="wrapper">
          <div class="title title-64">Welcome to BlockWrld!</div>
          <div class="desc-main desc medium">
            We’re excited to have you join our thriving community of Minecraft
            fans on the BlockWrld server. To keep the experience fun and fair
            for all, we’ve set some guidelines. Please read them before jumping
            into your next adventure!
          </div>
          <div class="card-list">
            <div class="card-item">
              <div class="desc regular">
                <b>[ General Conduct ]</b>
              </div>
              <div class="list">
                <div class="item">
                  <div class="desc desc-20">
                    <b>SHOW RESPECT</b>
                  </div>
                  <ul>
                    <li class="desc desc-20">
                      ● Treat everyone with kindness and respect.
                    </li>
                    <li class="desc desc-20">
                      ● Harassment, bullying, or offensive language will not be
                      tolerated.
                    </li>
                  </ul>
                </div>
                <div class="item">
                  <div class="desc desc-20">
                    <b>KEEP IT FAIR</b>
                  </div>
                  <ul>
                    <li class="desc desc-20">
                      ● Using cheats, exploits, or unapproved mods to gain an
                      advantage is strictly forbidden.
                    </li>
                  </ul>
                </div>
                <div class="item">
                  <div class="desc desc-20">
                    <b>RESPECT CREATIONS</b>
                  </div>
                  <ul>
                    <li class="desc desc-20">
                      ● Don’t destroy, alter, or damage other players’ builds.
                    </li>
                    <li class="desc desc-20">
                      ● Honor the boundaries and property of others.
                    </li>
                  </ul>
                </div>
                <div class="item">
                  <div class="desc desc-20">
                    <b>BUILD COMMUNITY</b>
                  </div>
                  <ul>
                    <li class="desc desc-20">
                      ● Foster teamwork and positive vibes.
                    </li>
                    <li class="desc desc-20">
                      ● Welcome new players and offer guidance when needed.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="card-item">
              <div class="desc regular">
                <b>[ Communication Guidelines ]</b>
              </div>
              <div class="list">
                <div class="item">
                  <div class="desc desc-20">
                    <b>KEEP IT CLEAN</b>
                  </div>
                  <ul>
                    <li class="desc desc-20">
                      ● Use language suitable for all players.
                    </li>
                    <li class="desc desc-20">
                      ● Avoid profanity or offensive comments.
                    </li>
                  </ul>
                </div>
                <div class="item">
                  <div class="desc desc-20">
                    <b>STAY SAFE</b>
                  </div>
                  <ul>
                    <li class="desc desc-20">
                      ● Never share personal information about yourself or
                      others.
                    </li>
                    <li class="desc desc-20">
                      ● Report any suspicious behavior to moderators
                      immediately.
                    </li>
                  </ul>
                </div>
                <div class="item">
                  <div class="desc desc-20">
                    <b>OFFER POSITIVE INPUT</b>
                  </div>
                  <ul>
                    <li class="desc desc-20">
                      ● Provide feedback that’s helpful and respectful.
                    </li>
                    <li class="desc desc-20">
                      ● Focus on improving the experience, not criticizing
                      others.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="card-item">
              <div class="desc regular">
                <b>[ Building and Creativity ]</b>
              </div>
              <div class="list">
                <div class="item">
                  <div class="desc desc-20">
                    <b>EXPRESS YOURSELF</b>
                  </div>
                  <ul>
                    <li class="desc desc-20">
                      ● Create freely through your builds, but keep them
                      appropriate and respectful.
                    </li>
                  </ul>
                </div>
                <div class="item">
                  <div class="desc desc-20">
                    <b>AVOID DISRUPTION</b>
                  </div>
                  <ul>
                    <li class="desc desc-20">
                      ● Don’t construct anything that intentionally interferes
                      with others’ gameplay.
                    </li>
                  </ul>
                </div>
                <div class="item">
                  <div class="desc desc-20">
                    <b>COLLABORATE ON PROJECTS</b>
                  </div>
                  <ul>
                    <li class="desc desc-20">
                      ● Join community builds with teamwork and follow their
                      guidelines.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="card-item">
              <div class="desc regular">
                <b>[ Enforcement and Reporting ]</b>
              </div>
              <div class="list">
                <div class="item">
                  <div class="desc desc-20">
                    <b>MODERATION SUPPORT</b>
                  </div>
                  <ul>
                    <li class="desc desc-20">
                      ● Our moderators work to maintain a safe and enjoyable
                      environment.
                    </li>
                    <li class="desc desc-20">
                      ● Report rule violations through our official channels.
                    </li>
                  </ul>
                </div>
                <div class="item">
                  <div class="desc desc-20">
                    <b>CONSEQUENCES FOR VIOLATIONS</b>
                  </div>
                  <ul>
                    <li class="desc desc-20">
                      ● Breaking rules may lead to warnings, temporary bans, or,
                      in serious cases, permanent bans.
                    </li>
                    <li class="desc desc-20">
                      ● We may remove players who repeatedly disrupt the
                      community.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="desc medium desc-main">
            Thank you for helping us create a welcoming and exciting
            environment! By following these rules, you help make BlockWrld a fun
            and respectful place for everyone. Let’s craft an amazing Minecraft
            community together!
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "Rules",
  props: [],
  components: {},
  data: function () {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
